<template>
  <div>
    <div class="card-container">
      <div class="card-title">
        图片筛选
      </div>
      <div class="card-content">
        <a-form ref="searchForm" :form="form">
          <a-row>
            <a-col :span="5">
              <a-form-item label="图片名称" v-bind="formItemLayout">
                <a-input v-model="imgName" allow-clear placeholder="请输入"></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="5">
              <a-form-item label="使用场景" v-bind="formItemLayout">
                <a-select
                  v-model="scene" allow-clear placeholder="请选择"
                  @select="showRegion"
                >
                  <a-select-option value="">
                    全部
                  </a-select-option>
                  <a-select-option value="1">
                    App端
                  </a-select-option>
                  <a-select-option value="2">
                    设备端
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col v-show="showArea" class="search-item" :span="5">
              <a-form-item
                :label-col="{ span: 5 }"
                :wrapper-col="{ span: 19 }"
                label="区域"
              >
                <a-cascader
                  v-model="region"
                  :options="options"
                  :load-data="loadData"
                  change-on-select
                  :field-names="{
                    label: 'name',
                    value: 'id',
                    children: 'children'
                  }"
                  placeholder="省市区、街道"
                />
              </a-form-item>
            </a-col>
            <a-col :span="5">
              <a-form-item label="状态" v-bind="formItemLayout">
                <a-select v-model="status" allow-clear placeholder="请选择">
                  <a-select-option value="">
                    全部
                  </a-select-option>
                  <a-select-option value="1">
                    启用
                  </a-select-option>
                  <a-select-option value="2">
                    禁用
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="4" align="right">
              <a-button type="primary" class="mr8" @click="toSearch">
                查询
              </a-button>
              <a-button @click="resetForm">
                重置
              </a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </div>
    <div class="card-container">
      <div class="card-title">
        <div class="title-desc">
          <span>图片内容列表</span>
          <span>
            <a-button type="primary" @click="toDetail()">
              <a-icon type="plus-circle" />
              新增
            </a-button>
          </span>
        </div>
      </div>
      <div class="card-content">
        <a-table
          class="table-content"
          :columns="columns"
          :data-source="dataList"
          :loading="loading"
          :pagination="pagination"
          :row-key="record => record.id"
          :scroll="{ x: 1500 }"
          @change="handleTableChange"
        >
          <template slot="position" slot-scope="text">
            <span v-if="text === 1">首页</span>
            <span v-else-if="text === 2">启动页</span>
          </template>
          <template slot="scene" slot-scope="text">
            <span v-if="text === 1">App端</span>
            <span v-else-if="text === 2">设备端</span>
          </template>
          <template slot="status" slot-scope="text">
            <span v-if="text === 1" class="tag"><span class="flag green"></span>启用</span>
            <span v-else-if="text === 2" class="tag"><span class="flag gray"></span>停用</span>
          </template>
          <template slot="imageInfos" slot-scope="text,record">
            <viewer style="height: 40px;" :images="record.imageInfos">
              <a
                v-for="(item, index) in record.imageInfos" :key="index"
                href="javascript:;"
              >
                <img
                  class="td-image"
                  :style="index == 0?'':'display:none;'"
                  :src="item.url"
                >
              </a>
            </viewer>
          </template>
          <div slot="action" slot-scope="record" class="btn-list">
            <a-button
              class="table-btn-link"
              type="link"
              size="small"
              icon="iconxiugai_huaban1"
              @click="toView(record)"
            >
              修改
            </a-button>
            <a-button
              class="table-btn-link"
              type="link"
              icon="iconshanchu_huaban1"
              size="small"
              @click="del(record)"
            >
              删除
            </a-button>
          </div>
        </a-table>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getArea,
  getEstate,
  iconFontComponent
} from '@/components/mixins/mixins.js'
import { getList, del } from '@/api/deviceOrder.js'
export default {
  mixins: [getArea, getEstate, iconFontComponent],
  data () {
    return {
      showArea: false,
      region: [],
      options: [],
      imgName: '',
      status: '',
      scene: '',
      form: this.$form.createForm(this, {}),
      formItemLayout: {
        labelCol: { span: 5 },
        wrapperCol: { span: 17 }
      },
      dataList: [],
      columns: [
        {
          title: '图片名称',
          dataIndex: 'name'
        },
        {
          title: '图片',
          dataIndex: 'imageInfos',
          scopedSlots: { customRender: 'imageInfos' }
        },
        {
          title: '图片位置',
          dataIndex: 'position',
          scopedSlots: { customRender: 'position' }
        },
        {
          title: '使用场景',
          dataIndex: 'scene',
          scopedSlots: { customRender: 'scene' }
        },
        {
          title: '更新时间',
          dataIndex: 'createTime'
        },
        {
          title: '图片状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '备注',
          dataIndex: 'remark'
        },
        {
          title: '操作',
          key: 'operation',
          fixed: 'right',
          width: 120,
          scopedSlots: { customRender: 'action' }
        }
      ],
      pagination: {
        current: 1,
        pageSize: 10,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: total => '共' + total + '条记录',
        pageSizeOptions: ['10', '20', '30', '40'],
        defaultPageSize: 10,
        total: 0
      },
      loading: false
    }
  },
  mounted () {
    this.getArea('', 2, null, true)
    this.getEstate()
    this.getList()
  },
  methods: {
    loadData (selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1]
      this.getArea(targetOption.id, targetOption.layer + 1, targetOption, true)
    },
    getList () {
      const parms = {
        scene: this.scene || '',
        provinceId: this.region[0] || '',
        cityId: this.region[1] || '',
        areaId: this.region[2] || '',
        name: this.imgName,
        page: this.pagination.current,
        pageSize: this.pagination.pageSize,
        status: this.status
      }
      getList(parms).then(res => {
        this.dataList = res.result
      })
    },
    // 显示区域
    showRegion (value) {
      value === '2' ? this.showArea = true : this.showArea = false
    },
    // 选择区域
    changeArea (areasId) {
      this.form.setFieldsValue({ estateId: undefined })
      if (areasId.length < 4) {
        this.getEstate(areasId)
      } else if (areasId.length === 4) {
        this.getEstate(null, areasId[3])
      }
    },
    toSearch () {
      this.getList()
    },
    resetForm () {
      this.scene = ''
      this.imgName = ''
      this.status = ''
      this.region = []
      this.getList()
      this.getEstate()
    },
    handleTableChange (pagination, filters, sorter) {
      const pager = { ...this.pagination }
      pager.current = pagination.current
      pager.pageSize = pagination.pageSize
      this.pagination = pager
      this.getList()
    },
    toDetail () {
      this.$router.push({
        path: '/equipment/maintain/imgAdd',
        query: {
          type: 'add'
        }
      })
    },
    toView (row) {
      console.log(row, '555')
      this.$router.push({
        path: '/equipment/maintain/imgAdd',
        query: {
          row: JSON.stringify(row),
          type: 'edit'
        }
      })
    },
    del (row) {
      del({ id: row.id }).then(res => {
        if (res.code === 0) {
          this.$message.success('删除成功！')
          this.getList()
        }
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.card-container
  .card-title
    .title-desc
      display flex
      align-items center
      span:nth-child(2)
        margin-left auto
.tag
  display flex
  flex-direction row
  align-items center
  .flag
    width 10px
    height 10px
    border-radius 50%
    margin-right 5px
    &.green
      background-color #57C22D
    &.gray
      background-color #8F96B3
</style>
